import fileDownload from 'js-file-download'
import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Container, PaginatedResponse } from '../../api/models'
import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from 'src/services/skuit/types'

export interface ExportProps {
  fields?: string[],
  exportFilters?: ExportFilters,
}

interface DetailProps {
  guid: string
  data?: any
  config?: CustomAxiosConfig
}

interface PatchProps {
  guid: string
  data: any
  config?: CustomAxiosConfig
}

export class Containers {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Container>> => {
    const response = await this.api.get('/logistics/containers', config)
    return paginatedTransform(Container)(response.data)
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Container> => {
    const response = await this.api.get(`/logistics/containers/${guid}`, config)
    return rawTransform(Container)(response.data)
  }

  lost = async (props: DetailProps): Promise<null> => {
    const { guid, data = {}, config = {} } = props
    await this.api.post(`/logistics/containers/${guid}/lost`, data, config)
    return null
  }

  found = async (props: DetailProps): Promise<null> => {
    const { guid, data = {}, config = {} } = props
    await this.api.post(`/logistics/containers/${guid}/found`, data, config)
    return null
  }

  create = async (data: any = {}, config: CustomAxiosConfig = {}): Promise<Container[]> => {
    const response = await this.api.post('/logistics/containers/bulk', data, config)
    return response.data.map((containerItem: any) => rawTransform(Container)(containerItem))
  }

  patch = async ({ guid, data, config = {} }: PatchProps): Promise<Container> => {
    const response = await this.api.patch(`/logistics/containers/${guid}`, data, config)
    return rawTransform(Container)(response.data)
  }

  delete = async (guid: string, config: CustomAxiosConfig = {}): Promise<null> => {
    await this.api.delete(`/logistics/containers/${guid}`, config)
    return null
  }

  export = async ({ fields=[], exportFilters }: ExportProps) => {
    const params = { fields: fields.join(','), ...exportFilters }
    const response = await this.api.axiosInstance({
      url: '/logistics/containers/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'containers.csv')
  }
}
